import { useTheme } from '@mui/material';

import { IconSvgProps } from './Icon';

type BaseLibraryIconSvgProps = IconSvgProps;
export default function BaseLibraryIconSvg({
  name,
  color,
  width = 24,
  children,
  classname,
  viewBox = '0 0 24 24',
  ...svgProps
}: BaseLibraryIconSvgProps) {
  const { typography } = useTheme();
  return (
    <svg
      viewBox={viewBox}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ width: typography.pxToRem(width), height: 'auto', color }}
      className={classname}
      data-testid={name}
      {...svgProps}
    >
      {children}
    </svg>
  );
}
